import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from "react-router-dom";
import './index.css';
import './lib/css/grid.css';
import './lib/css/site.css';
import './lib/css/login.css';
import "primereact/resources/themes/lara-light-indigo/theme.css";
import App from './App';


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <BrowserRouter>
  <App />
  </BrowserRouter>
   
);

